import { ApolloQueryResult } from "@apollo/client";
import { Maybe } from "graphql/jsutils/Maybe";
import { cloneElement, useEffect, useRef } from "react";
import useInfiniteScroll from "../hooks/use-infinite-scroll";

interface InfiniteScrollViewProps {
	refetch: (variables?: any) => Promise<ApolloQueryResult<any>>;
	data: Array<Maybe<any>>;
	initialValue: number;
	children: React.ReactNode;
	increment?: number;
	isInfiniteScrollDisabled?: boolean;
}

const InfiniteScrollView: React.FC<InfiniteScrollViewProps> = ({
	refetch,
	data,
	initialValue,
	children,
	increment,
	isInfiniteScrollDisabled,
}) => {
	const increments = increment || 3;
	const loader = useRef(null);
	const pagination = useRef(initialValue);
	const dataLengthRef = useRef(0);

	useEffect(() => {
		dataLengthRef.current = data?.length;
	}, [data?.length]);

	const handleUpdateState = () => {
		if (pagination.current === dataLengthRef.current) {
			pagination.current = pagination.current + increments;
			refetch({
				first: pagination.current,
			});
		}
	};

	useInfiniteScroll(loader, handleUpdateState);

	return (
		<>
			{children && typeof children !== "string" && cloneElement(children as any, { ...data })}
			{!isInfiniteScrollDisabled && <div ref={loader} style={{ marginTop: "-5px" }} />}
		</>
	);
};

export default InfiniteScrollView;
